// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1xUUX","ranges":"BmiRanges_ranges__3zQew"};